import { Button } from '@mui/material';
import { styled } from '@mui/system';
import COLORS from '../../../../../theme/Colors'
import FONTS_FAMILY from '../../../../../theme/FontsFamily';

export const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'transparent',
    boxSizing: 'border-box',
    width: '100%',
    maxWidth: '480px',
    margin: '0 auto',
});

export const Header = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: 'transparent',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px 0 12px 0',
    boxSizing: 'border-box',
});

export const Body = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '8px 0',
    boxSizing: 'border-box',
    gap: '8px',
    width: '100%',
});

export const HeaderTitle = styled('h1')({
    color: '#0F2350',
    margin: '4px 0 0 0',
    fontFamily: FONTS_FAMILY.bold.title,
    fontSize: '34px',
    fontWeight: '800',
});

export const HeaderSubTitle = styled('h4')({
    color: '#0B8296',
    margin: 0,
    fontFamily: FONTS_FAMILY.bold.title,
    fontSize: '13px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
});

export const BodyTitle = styled('p')({
    color: '#0F2350',
    margin: '2px 0 0 0',
    fontFamily: FONTS_FAMILY.bold.title,
    fontSize: '16px',
    fontWeight: '700',
});

export const BodySubTitle = styled('p')({
    color: '#57697F',
    margin: 0,
    fontFamily: FONTS_FAMILY.bold.body,
    fontSize: '12px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
});

export const ButtonsContainer = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    width: '100%',
    padding: '20px 0 0 0',
    boxSizing: 'border-box',
});

export const CardButton = styled(Button)({
    height: '48px',
    width: '100%',
    color: '#FFFFFF',
    backgroundColor: '#0F2350',
    borderRadius: '12px',
    textTransform: 'none',
    fontFamily: FONTS_FAMILY.bold.body,
    fontSize: '15px',
    fontWeight: '700',
    boxShadow: 'none',
    transition: 'all 0.2s ease',
    '&:hover': {
        backgroundColor: '#EA361A',
        color: '#FFFFFF',
        transform: 'translateY(-1px)',
        boxShadow: 'none',
    },
    '&:active': {
        transform: 'translateY(0)',
    }
});
